const red = document.querySelector(".red")
const cyan = document.querySelector(".cyan")
const violet = document.querySelector(".violet")
const orange = document.querySelector(".orange")
const pink = document.querySelector(".pink")

const center = document.querySelector(".center")

// Displays all the computed styles for the class .red
// console.log(window.getComputedStyle(red));

// Displays all the computed styles for the class .red's background property
// console.log(window.getComputedStyle(red).backgroundColor);

// Displays all the computed styles for the class .red's border radius property
// Make sure the computed style always has the camelCase format
// console.log(window.getComputedStyle(red).borderRadius);

const getBGColor = (e) => {
    console.log(`The Computed Style for the color is :
    ${window.getComputedStyle(e).backgroundColor}`)
}

getBGColor(orange);
getBGColor(pink);
getBGColor(red);
getBGColor(cyan);

